import styled from "styled-components";
import images from "../images";
import { DESKTOP_MEDIA_QUERY } from "../constants";

export const Wrapper = styled.div`
  padding: 12px 16px;
`;

export const Block = styled.div`
  padding-left: 63px;
  margin-bottom: 10px;

  ${DESKTOP_MEDIA_QUERY} {
    max-width: 1200px;
    margin: 0 auto 25px;
    padding-left: 55px;
  }
`;

export const One = styled(Block)`
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 80px;
  border-radius: 25px;
  background-color: #0000ff;
  background-image: url(${images.instructions_1.src});
  background-repeat: no-repeat;
  background-size: 32px;
  background-position: 17px center;
  font-size: 16px;
  font-weight: 600;
  color: #fff;

  ${DESKTOP_MEDIA_QUERY} {
    padding-right: 40px;
    background-image: none;
    border-radius: 0;
    font-size: 46px;
  }
`;

export const Two = styled(Block)`
  min-height: 40px;
  padding-right: 60px;
  background-image: url(${({ n }) => images[`instructions_${n}`].src});
  background-repeat: no-repeat;
  background-size: 32px;
  background-position: 17px center;
  font-size: 12px;

  ${DESKTOP_MEDIA_QUERY} {
    padding-left: 100px;
    font-size: 24px;
    background-position: 55px center;
  }
`;

export const Three = styled(Block)`
  padding: 6px;
  margin-left: 63px;
  background-color: #0000ff;
  font-size: 12px;
  color: #fff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 24px;
  }
`;

export const Four = styled(Block)`
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  border: 2px solid #0000ff;
  border-radius: 25px;
  background-image: url(${images.instructions_6.src});
  background-repeat: no-repeat;
  background-size: 32px;
  background-position: 17px 14px;
  font-size: 16px;
  font-weight: 600;
  color: #0000ff;

  ${DESKTOP_MEDIA_QUERY} {
    padding-left: 100px;
    font-size: 24px;
    background-position: 55px 17px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 2px;
`;
